import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "sonner";
import AppShell from "@/components/travel/AppShell";
import AiWidget from "@/components/travel/AiWidget";
import OnboardingTour from "@/components/travel/OnboardingTour";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import TripWizard from "@/pages/TripWizard";
import Search from "@/pages/Search";
import Dashboard from "@/pages/Dashboard";
import Messages from "@/pages/Messages";
import Profile from "@/pages/Profile";
import Admin from "@/pages/Admin";
import PaymentSuccess from "@/pages/PaymentSuccess";
import { About, Terms } from "@/pages/Static";
import Settings from "@/pages/Settings";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";

function AppRouter() {
  const location = useLocation();
  // Emergent Google auth callback lands with #session_id in the fragment
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <AppShell>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/wizard" element={<TripWizard />} />
        <Route path="/search" element={<Search />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/messages" element={<Messages />} />
        <Route path="/messages/:contactId" element={<Messages />} />
        <Route path="/profile/:userId" element={<Profile />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<div className="p-8 text-center text-slate-300">Paiement annulé.</div>} />
        <Route path="/about" element={<About />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/terms" element={<Terms />} />
      </Routes>
      <AiWidget />
      <OnboardingTour />
    </AppShell>
  );
}

export default function App() {
  return (
    <div className="dark">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster theme="dark" position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
